export interface HeadHitSample { previousTop: number; currentTop: number; blockBottom: number; velocityY: number; }

/** True only while a body crosses a block's underside on the way up. */
export function isExactHeadHit({ previousTop, currentTop, blockBottom, velocityY }: HeadHitSample): boolean {
  return velocityY < 0 && previousTop >= blockBottom && currentTop <= blockBottom;
}

export function jumpPeakY(startTop: number, jumpVelocity: number, gravity: number): number {
  return startTop - (jumpVelocity * jumpVelocity) / (2 * gravity);
}

export function jumpPositionY(groundY: number, elapsedSeconds: number, jumpVelocity: number, gravity: number): number {
  return groundY + jumpVelocity * elapsedSeconds + 0.5 * gravity * elapsedSeconds * elapsedSeconds;
}
